import React, { useReducer } from 'react';

import { passIf } from '@utils';
import { BaseText, IBaseTextProps } from './BaseText';

export interface ITextTruncatedProps extends IBaseTextProps {
  isExpanded?: boolean;
}

export function TextTruncated({
  isExpanded: initExpanded = false,
  numberOfLines = 1,
  children,
  ...props
}: ITextTruncatedProps) {
  const [isExpanded, toggleExpanded] = useReducer(
    (prev) => !prev,
    initExpanded,
  );

  return (
    <BaseText
      onPress={toggleExpanded}
      numberOfLines={passIf(!isExpanded, numberOfLines)}
      {...props}
    >
      {children}
    </BaseText>
  );
}
